// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-file-message-wrap {
  display: flex;
  flex-direction: row;
}
.chat-file-message-wrap.myself {
  flex-direction: row-reverse;
}

.chat-file-message-item {
  width: 320px;
  height: 60px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 15px;
  cursor: pointer;
  flex: 0 1 auto;
}
.chat-file-message-item .chat-file-preview {
  margin-right: 18px;
  position: relative;
}
.chat-file-message-item .chat-file-preview .chat-file-icon {
  display: inline-block;
}
.chat-file-message-item .chat-file-preview .chat-file-icon svg {
  width: 32px;
  height: 32px;
}
.chat-file-message-item .chat-file-preview .chat-file-status {
  position: absolute;
  right: 0;
  bottom: 0;
  transform: translate(50%, 50%);
  border-radius: 50%;
}
.chat-file-message-item .chat-file-preview .chat-file-status svg {
  width: 16px;
  height: 16px;
}
.chat-file-message-item .chat-file-desc {
  overflow: hidden;
  max-width: 240px;
}
.chat-file-message-item .chat-file-desc .chat-file-name {
  color: #232333;
  font-weight: 700;
  font-size: 14px;
  width: 100%;
  margin: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  text-align: left;
}
.chat-file-message-item .chat-file-desc .chat-file-subline {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.chat-file-message-item .chat-file-desc .chat-file-subline .chat-file-size {
  margin-right: 5px;
  white-space: nowrap;
}
.chat-file-message-item .chat-file-desc .chat-file-subline .ant-progress {
  width: 150px;
}
.chat-file-message-item .chat-file-desc .chat-file-subline .ant-btn {
  border: 0;
}
.chat-file-message-item .chat-file-desc .chat-file-action-tip {
  visibility: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: hidden;
}
.chat-file-message-item:hover .chat-file-action-tip {
  visibility: visible;
}`, "",{"version":3,"sources":["webpack://./src/feature/chat/component/chat-file-message-item.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;AACF;AAAE;EACE,2BAAA;AAEJ;;AAEA;EACE,YAAA;EACA,YAAA;EACA,oCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AACF;AAAE;EACE,kBAAA;EACA,kBAAA;AAEJ;AADI;EACE,qBAAA;AAGN;AAFM;EACE,WAAA;EACA,YAAA;AAIR;AAAI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,kBAAA;AAEN;AAAM;EACE,WAAA;EACA,YAAA;AAER;AAEE;EACE,gBAAA;EACA,gBAAA;AAAJ;AACI;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AACN;AACI;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AACN;AAAM;EACE,iBAAA;EACA,mBAAA;AAER;AAAM;EACE,YAAA;AAER;AAAM;EACE,SAAA;AAER;AACI;EACE,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AACN;AAGI;EACE,mBAAA;AADN","sourcesContent":[".chat-file-message-wrap{\n  display: flex;\n  flex-direction: row;\n  &.myself {\n    flex-direction: row-reverse;\n  }\n  \n}\n.chat-file-message-item {\n  width: 320px;\n  height: 60px;\n  border: 1px solid rgba(0, 0, 0, 10%);\n  border-radius: 12px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 10px 15px;\n  cursor: pointer;\n  flex: 0 1 auto;\n  .chat-file-preview {\n    margin-right: 18px;\n    position: relative;\n    .chat-file-icon{\n      display: inline-block;\n      svg {\n        width: 32px;\n        height: 32px;\n      }\n      \n    }\n    .chat-file-status {\n      position: absolute;\n      right: 0;\n      bottom: 0;\n      transform: translate(50%, 50%);\n      border-radius: 50%;\n\n      svg {\n        width: 16px;\n        height: 16px;\n      }\n    }\n  }\n  .chat-file-desc {\n    overflow: hidden;\n    max-width: 240px;\n    .chat-file-name {\n      color: #232333;\n      font-weight: 700;\n      font-size: 14px;\n      width: 100%;\n      margin: 0;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      overflow: hidden;\n      text-align: left;\n    }\n    .chat-file-subline {\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      overflow: hidden;\n      .chat-file-size {\n        margin-right: 5px;\n        white-space: nowrap;\n      }\n      .ant-progress{\n        width: 150px;\n      }\n      .ant-btn {\n        border: 0;\n      }\n    }\n    .chat-file-action-tip {\n      visibility: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      overflow-x: hidden;\n    }\n  }\n  &:hover {\n    .chat-file-action-tip {\n      visibility: visible;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
